<div class="sticky top-0 flex flex-col w-full gap-1 px-4 overflow-x-hidden z-49">
  <div class="flex items-start justify-between w-full" #backButton>
    <button mat-icon-button (click)="back()" class="-ml-4 text-accent">
      <mat-icon
        class="icon-size-5 text-accent"
        [svgIcon]="
          currentPage === 'category-list' || isFundingDetail
            ? 'heroicons_solid:x-mark'
            : 'heroicons_solid:arrow-left'
        "
      ></mat-icon>
    </button>
    @if (currentPage !== 'category-list' && !isFundingDetail) {
      <button mat-icon-button (click)="close.emit()" class="-mr-4 text-accent">
        <mat-icon class="icon-size-5 text-accent" [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
      </button>
    }
  </div>
  @if (currentPage === 'category-list') {
    <div @fadeInLeft>
      <span class="mb-1 text-3xl font-bold"> Buscar inversiones </span>
      <!-- <form [formGroup]="searchForm" class="mt-2">
        <mat-form-field appearance="fill" class="w-full" [subscriptSizing]="'dynamic'">
          <input placeholder="Busca inversiones" matInput formControlName="search" />
          <mat-icon matPrefix>search</mat-icon>
        </mat-form-field>
      </form> -->
      @if (!categorySummaryDetail?.length) {
        <span @fadeIn bp-text-values-card>Lo siento, no hay resultados para tu búsqueda. </span>
      }
      <div class="flex flex-col w-full mt-4">
        @for (sc of subCategoryWithFundsFiltered; track sc; let last = $last) {
          <div class="flex flex-col">
            <div
              class="flex items-center justify-between w-full py-1"
              matRipple
              (click)="selectCategory(sc); next()"
            >
              <span class="w-full cursor-pointer">{{ sc.category.categoryDisplayName }}</span>
              <button mat-icon-button>
                <mat-icon
                  class="icon-size-4"
                  [svgIcon]="'heroicons_outline:chevron-right'"
                ></mat-icon>
              </button>
            </div>
            <!-- @if (search?.value) {
              @if (!last || search?.value) {
                <mat-divider class="w-full"></mat-divider>
              }
              <div class="flex flex-col gap-2 mt-2">
                @for (fund of sc.customFunds; track fund) {
                  <div class="flex flex-row items-center gap-2 -ml-2" matRipple>
                    @if (isCustomFundAdded(fund)) {
                      <button
                        (click)="removeCustomCategoryFund(fund)"
                        mat-icon-button
                        [color]="'warn'"
                      >
                        <mat-icon
                          class="icon-size-5"
                          [svgIcon]="'heroicons_solid:x-mark'"
                        ></mat-icon>
                      </button>
                    }
                    @if (!isCustomFundAdded(fund)) {
                      <button (click)="addCustomCategoryFund(fund)" mat-icon-button>
                        <mat-icon class="icon-size-5" [svgIcon]="'mat_outline:add'"></mat-icon>
                      </button>
                    }
                    <div
                      class="w-full cursor-pointer"
                      (click)="selectCustomFund(fund); next('fund-detail')"
                    >
                      <span class="text-accent"> {{ fund.fund.fund?.title }} </span>
                      <br class="" />
                      <span class="text-sm font-normal" bp-text-values-card>
                        {{ fund.fund.fund?.mnemonic }}
                      </span>
                    </div>
                    <button mat-icon-button (click)="selectCustomFund(fund); next('fund-detail')">
                      <mat-icon
                        class="icon-size-4"
                        [svgIcon]="'heroicons_outline:chevron-right'"
                      ></mat-icon>
                    </button>
                  </div>
                }
              </div>
            } -->
          </div>
        }
      </div>
    </div>
  }

  @if (currentPage === 'funds-list') {
    <div [@fadeInRight]="lastPage === 'category-list'" [@fadeInLeft]="lastPage === 'fund-detail'">
      <div class="flex flex-col gap-2">
        <span class="text-3xl font-bold">
          {{ categorySelected?.categoryDisplayName }}
        </span>
        <span>
          {{ categorySelected?.categoryDescription }}
        </span>
        <div class="flex flex-col w-full mt-1 gap-4">
          <mat-form-field class="fuse-mat-rounded" [subscriptSizing]="'dynamic'" ngDefaultControl>
            <mat-icon matPrefix>search</mat-icon>
            <input
              matInput
              placeholder="Buscador"
              name="searchControl"
              [formControl]="searchControl"
            />
          </mat-form-field>
          <mat-button-toggle-group
            name="tags"
            aria-label="tags"
            class="flex flex-wrap gap-2"
            style="zoom: 0.8"
            multiple
            [formControl]="toggleControl"
          >
            @for (fundingTag of fundingTags; track fundingTag.id) {
              <mat-button-toggle [value]="fundingTag.id">
                <span class="text-black">
                  {{ fundingTag.shortName?.value }}
                </span>
              </mat-button-toggle>
            }
          </mat-button-toggle-group>
        </div>

        <div class="block w-full mt-2">
          @for (fund of filteredFunds; track fund.fundingId) {
            <div class="flex flex-row items-center gap-4 -ml-2 py-3" matRipple>
              <app-discover-fund-avatar
                class="flex-shrink-0"
                [fund]="fund"
                [index]="$index"
                size="36px"
              ></app-discover-fund-avatar>

              <!-- @if (isCustomFundAdded(fund.fund.fundingId)) {
                <button mat-icon-button [color]="'warn'">
                  <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
                </button>
              }
              @if (!isCustomFundAdded(fund.fund.fundingId)) {
                <button mat-icon-button (click)="addCustomCategoryFund(fund)">
                  <mat-icon class="icon-size-5" [svgIcon]="'mat_outline:add'"></mat-icon>
                </button>
              } -->
              <!--  -->
              <div class="w-full cursor-pointer" (click)="selectCustomFund(fund); next()">
                <span class="text-accent"> {{ fund?.title }} </span>
                <br class="" />
                <span class="text-sm font-normal" bp-text-values-card>
                  {{ fund?.mnemonic?.value }}
                </span>
              </div>
              <!--  -->
              <button mat-icon-button (click)="selectCustomFund(fund); next()">
                <mat-icon
                  class="icon-size-4"
                  [svgIcon]="'heroicons_outline:chevron-right'"
                ></mat-icon>
              </button>
            </div>
          }
        </div>
      </div>
    </div>
  }
  @if (currentPage === 'fund-detail' && !isLoadingSpecificFund()) {
    <app-funds-detail-search-funds
      [funding]="isFundingDetail ? funding : fundSelected"
      [isCustomFundAdded]="isCustomFundAdded(summaryFundingSelected?.fundingId)"
      [isFundingDetail]="isFundingDetail"
      (addCustomCategoryFund)="addCustomCategoryFund(summaryFundingSelected)"
      (removeCustomCategoryFund)="removeCustomCategoryFund(customFundSelected)"
    ></app-funds-detail-search-funds>
  }
</div>
